module.exports = __webpack_public_path__ + "static/media/landing-mobile-work.d7f38579.png";